import { Heading } from 'components/elements';
import { styled } from 'styles';

export const PageHeaderBreadcrumbsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledPageHeader = styled(Heading).attrs({
  size: 1,
})`
  overflow: hidden;
  text-overflow: ellipsis;
`;

PageHeaderBreadcrumbsWrapper.displayName = 'PageHeaderBreadcrumbsWrapper';
StyledPageHeader.displayName = 'PageHeader.Styled';
